export default __webpack_public_path__ + "static/media/Arcane Shield.9f073e6b.jpg";